import { func } from 'prop-types';
import React, { Component } from 'react';
import { Fragment } from 'react';
import { translate } from '../Services/translation';
import WooDate from './WooCode/WooDate';

class RegisterMe extends Component {
    constructor(props) {
        super(props);
        this.state = {
            didMount: false,
        };

        this.fetchRegistrationFormByType(this.props.channeltype);
    }

    componentDidMount() {
        //setTimeout(() => this.subscribeToEvents(), 1000);
    }

    subscribeToEvents() {
        window._briqpay.subscribe('signup_finalized', (status) => {
            if (status === 'success') {
                this.props.briqPayLogin();
            }
        })
    }

    fillMeUp() {
        const { getFields, type, softlogintoken } = this.props;

        if (getFields) {
            getFields(type, softlogintoken);
        }
    }

    fetchRegistrationFormByType(channeltype) {
        if (channeltype == "B2C")
            this.fillMeUp();
        else if (channeltype === "B2B")
            this.fetchRegistrationHtmlSnippet();
    }

    fetchRegistrationHtmlSnippet() {
        const { getHtmlSnippet } = this.props;
        if (getHtmlSnippet) {
            getHtmlSnippet();
        }
    }

    updateField(e) {
        const { fields } = this.props;
        const id = e.target.id;
        let value = "";
        if (id === "_email") {
            value = e.target.value.replace(/ /g,'');
        } else {
            value = e.target.value
        }
        fields.map(item => {
            if (item.fieldId === id) {
                item.fieldValue =
                    item.fieldType === 'Checkbox' ? e.target.checked : value;
            }
        });
    }

    sendData() {
        const { saveMember, fields, softlogintoken } = this.props;
        fields.map((item, index) => {
            item.validatorMessage = null;
        });
        saveMember({
            fields: fields,
            softlogintoken: softlogintoken,
        });
    }

    InputType(item) {
        switch (item.fieldType) {
            case 'TextOption':
                return this.renderTextOptionInput(item);
            case 'Date':
                return this.renderDateInput(item);
            case 'Text':
            case 'Password':
                return this.renderTextInput(item);
            case 'Checkbox':
                return this.renderCheckbox(item);
            default:
                console.error(
                    `Unknown FieldType:${item.fieldType} FieldId:${item.fieldId}`,
                );
        }
    }

    renderTextInput(item) {
        return (
            <input
                id={item.fieldId}
                onBlur={e => this.updateField(e)}
                type={item.fieldType}
                placeholder={item.fieldId === "_phone" ? translate(`registerme.phonenumber`) : item.fieldName}
                disabled={
                    this.props.softlogintoken &&
                    item.fieldId === '_email' &&
                    item.fieldValue
                }
                defaultValue={item.fieldValue}
            ></input>
        );
    }

    renderTextOptionInput(item) {
        let options = JSON.parse(item.fieldOrgValue);
        return (
            <select
                id={item.fieldId}
                name={item.fieldId}
                onBlur={e => this.updateField(e)}
                required
                defaultValue={
                    (this.props.softlogintoken && item.fieldValue) || ''
                }
            >
                <option value="" disabled hidden>
                    {translate(`registerme.placeholder.${item.fieldId}`)}
                </option>
                {options.map((item, index) => (
                    <option key={index} value={item.Value}>
                        {item.Key}
                    </option>
                ))}
            </select>
        );
    }

    renderDateInput(item) {
        return (
            <WooDate
                item={{
                    id: item.fieldId,
                    name: item.fieldId,
                    defaultValue: item.fieldValue,
                }}
                onBlur={e => this.updateField(e)}
                defaultValue={item.fieldValue}
                placeholder={item.fieldName}
            />
        );
    }

    renderCheckbox(item) {
        return (
            <input
                id={item.fieldId}
                onChange={e => this.updateField(e)}
                type={item.fieldType}
                defaultChecked={
                    item.fieldId === 'Consent' && item.fieldValue === 'True'
                        ? true
                        : false
                }
            ></input>
        );
    }

    renderRegistrationPicker() {
        return (
            <>
                <label className="form__label" for="registrationTypeSelector">{translate(`registerme.registrationtypeselect.label`)}</label>
                <select
                    id="registrationTypeSelector"
                    className="registerMeTypeSelector"
                    onChange={e => 
                        this.fetchRegistrationFormByType(e.target[e.target.selectedIndex].id)}
                >
                    <option id="B2C">
                        {translate(`registerme.registrationtypeselect.b2c`)}
                    </option>
                    <option id="B2B">
                        {translate(`registerme.registrationtypeselect.b2b`)}
                    </option>
                </select>
            </>
        );
    }

    renderB2bRegistration(htmlSnippet) {
        return (
            <div dangerouslySetInnerHTML={{__html: htmlSnippet}}/>
        );
    }

    render() {
        const { fields, status, redirectUrl, htmlSnippet, displayregistrationpicker, briqpayLoginSuccess } = this.props;
        let redirectTimeout = undefined;
        if (status || briqpayLoginSuccess) {
            redirectTimeout = setTimeout(() => {
                window.location.href = redirectUrl;
            }, 1000);
            return (
                <div className="registerMe">
                    {htmlSnippet && (
                        <div>
                            <h1>{translate(`registermeb2b.header`)}</h1>
                        </div>
                    )}
                    <p>{translate(status)}</p>
                </div>
            );
        } else if (fields || htmlSnippet) {
            return (
                <div className="registerMe">
                    {htmlSnippet && (
                        <div>
                            <h1>{translate(`registermeb2b.header`)}</h1>
                        </div>
                    )}
                    {displayregistrationpicker && displayregistrationpicker === "True" && this.renderRegistrationPicker()}
                    {htmlSnippet && this.renderB2bRegistration(htmlSnippet)}
                    {fields &&
                        fields.map((item, index) => (
                            <Fragment key={index}>
                                <div className="registerMeRow">
                                    <div className="validatorMessage">
                                        {item.validatorMessage}
                                    </div>
                                    <div className="registerMeColumn">
                                        {item && this.InputType(item)}
                                        {item.fieldId === 'Consent' && (
                                            <span
                                                className="consent"
                                                dangerouslySetInnerHTML={{
                                                    __html: this.props.gdprText,
                                                }}
                                            ></span>
                                        )}
                                    </div>
                                </div>
                            </Fragment>
                        ))}

                    {fields && <>
                        <div className="registerMeRow">
                            <button
                                className="form__button form__button--expand"
                                onClick={() => this.sendData()}
                            >
                                {translate('registerme.buttontext')}
                            </button>
                        </div>
                    </>}
                </div>
            );
        }
    }
}

export default RegisterMe;
